import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\var\\coverz_ui\\src\\components\\pages\\stem-splitter\\stem-splitter.tsx");
